import moment from "moment";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { translateString } from "../../translations/gridTranslationHelper";
import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../types/configColumns2";
import { Culture } from "../../types/culture";
import { LineWoSchedule } from "../../types/lineWoSchedule";

const labelsSchedulingColumnsSchedule = (culture: Culture, isUsSite: boolean): ConfigColumns2[] => {
    const operationId = { data: "operationId", visible: false, title: "operationId" };
    const scheduleOrder = { data: "scheduleOrder", width: "5%", title: translateString("priority", culture) };
    const workorder = { data: "workorder", className: "nowrap", width: "12%", title: translateString("workOrder", culture) };
    const batch = { data: "batch", className: "nowrap", width: "12%", title: translateString("batch", culture) };
    const startDateTime = {
        data: "startDateTime",
        width: "30%",
        title: translateString("startDate", culture),
        render: function (data: LineWoSchedule, type: ColumnFilterOrDisplayType | undefined) {
            if(!data.startDateTime) return "";
            if (type === "display") return momentDtoToLocalStringByCulture(moment(data.startDateTime).toDate(), culture);
            return moment(data.startDateTime).toDate();
        }
    };
    const endDateTime = {
        data: "endDateTime",
        width: "30%",
        title: translateString("endDate", culture),
        render: function (data: LineWoSchedule, type: ColumnFilterOrDisplayType | undefined) {
            if(!data.endDateTime) return "";
            if (type === "display") return momentDtoToLocalStringByCulture(moment(data.endDateTime).toDate(), culture);
            return moment(data.endDateTime).toDate();
        }
    };
    
    if(isUsSite) {
        return [operationId, scheduleOrder, workorder, startDateTime, endDateTime];
    }
    else {
        return [operationId, workorder, batch, startDateTime, endDateTime];
    }
};

export { labelsSchedulingColumnsSchedule };
